module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-modular-row clearfix"
  }, [_c('label', {
    staticClass: "kp-modular-label"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.font')))]), _vm._v(" "), _c('select', {
    staticClass: "klickart-select",
    on: {
      "change": function($event) {
        return _vm.onChange($event)
      }
    }
  }, _vm._l((_vm.fontFamilies), function(font) {
    return _c('option', {
      domProps: {
        "value": font.value,
        "selected": font.value === _vm.stepStyle(_vm.item).fontFamily
      }
    }, [_vm._v(_vm._s(font.label))])
  }), 0)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-1a099c90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/modifiers/editors/FontFamily.vue
 ** module id = 775
 ** module chunks = 1
 **/